// tea参数默认值
const BE_NULL = 'be_null';

const getAppType = () => {
  const UA = navigator.userAgent;
  switch (true) {
    case /(NewsArticle)[\s/_](\d.\d.\d)/i.test(UA):
      return 'toutiao';
    case /aweme/i.test(UA):
      return 'douyin';
    case /live_stream_\d+/i.test(UA):
      return 'huoshan';
    case /VideoArticle/i.test(UA):
      return 'xigua';
    case /Super \d.\d.\d/i.test(UA):
      return 'pipixia';
    case /BDGameSDK/i.test(UA):
      return 'game';
    case /MicroMessenger/i.test(UA):
      return 'wechat';
    case / QQ/i.test(UA):
      return 'qq';
    case /-bcy\/\d.\d.\d/.test(UA):
      return 'banciyuan';
    default:
      return 'unknow';
  }
};

function parseQuery(): { [key: string]: any } {
  const { search } = location;
  const r = /([^=&?#]+)=([^&#]*)/g;
  const matches = search.match(r);
  if (!matches || !matches.length) {
    return {};
  }
  const query = {};
  matches.forEach(str => {
    const idx = str.indexOf('=');
    query[str.substr(0, idx)] = decodeURIComponent(str.substr(idx + 1));
  });
  return query;
}

// 地理位置信息
let HAS_FETCHED_GEO = false;
let HAS_START_FETCH_GEO = false;
let geoInfo = {
  city: BE_NULL,
  continent: BE_NULL,
  country: BE_NULL,
  subdivisions: BE_NULL,
};

let isNode = typeof window === 'undefined';

// app_id
let HAS_INITED_APP_ID = false;
let APP_ID = (function () {
  // 如是在红砖模版，直接取window.runtime
  if (!isNode && window.runtime) {
    const { appId } = window.runtime;
    HAS_INITED_APP_ID = true;
    return appId;
  }
  // 如果在game-tool-cli模版，没有预留占位符，需要用户初始化
  return null;
})();

// activity_id
let HAS_INITED_ACTIVITY_ID = false;
let ACTIVITY_ID = (function () {
  // 如是在红砖模版，直接取window.runtime
  if (!isNode && window.runtime) {
    const { actId } = window.runtime;
    HAS_INITED_ACTIVITY_ID = true;
    return actId;
  }
  // 如果在game-tool-cli模版，没有预留占位符，需要用户初始化
  return null;
})();

// 区域
let AREA_SIGNAL = 'cn';
let DEFAULT_DATA = {};

// URL query参数
const QUERY = (function () {
  return isNode ? Object.create(null) : parseQuery();
})();

// event_id
const RANDOM_CHARS = '0123456789abcdefghijkABCDEFGHIJK';
const genRandomStr = (length) => {
  let re = '';
  const charLen = RANDOM_CHARS.length;
  for (let i = 0; i < length; i++) {
    re += RANDOM_CHARS[Math.floor(Math.random() * charLen)];
  }
  return re;
};
const EVENT_ID = genRandomStr(32) || '';

// get session_id
const getSessionId = () => {
  let sessionid = sessionStorage.getItem('SESSION_ID');
  if (!sessionid) {
    sessionid = genRandomStr(32);
    sessionStorage.setItem('SESSION_ID', sessionid);
  }
  return sessionid;
};

// 获取页面打开来源
let LAUNCH_FROM;

// 系统
let OS;
const getOS = () => {
  if (/iPhone/i.test(navigator.userAgent)) {
    return 'ios';
  } else if (/Android/i.test(navigator.userAgent)) {
    return 'android';
  } else {
    return 'pc';
  }
};

// 是否初始化header头信息
let HAS_CONFIG_CUS_HEADER = false;
const getCustomsHeader = () => {
  // 1. 正式环境：environment ='product'
  // 2. 沙箱环境：environment ='sandbox'
  // 3. BOE正式环境：environment ='boe-product'
  // 4. BOE沙箱环境：environment ='boe-sandbox'
  const hostname = location.hostname;
  if (hostname.indexOf('boe-act.bytedance.net') > -1) {
    return 'boe-sandbox';
  }
  if (hostname.indexOf('boe-act-internal.bytedance.net') > -1) {
    return 'boe-product';
  }
  if (
    hostname.indexOf('.bytedance.net') > -1 ||
    hostname.indexOf('sandbox') > -1 ||
    hostname.indexOf('localhost') > -1
  ) {
    return 'sandbox';
  }
  return 'product';
};

const defaultLogMessageFn = (event, params) => {
  params = params || {};
  console.log('');
  console.log('========= 埋点上报 =========');
  console.log('上报时间：', new Date().toLocaleString());
  console.log('事件名称：', event);
  console.log('事件参数：', JSON.stringify(params, null, 2));
  console.log('');
};

const preInstallTeaSdk = (zone) => {
  return new Promise((resolve) => {
    const teaPre = document.createElement('script');
    const teaSdk = document.createElement('script');
    teaPre.innerHTML = `
      (function (win, export_obj) {
        win['TeaAnalyticsObject'] = export_obj;
        if (!win[export_obj]) {
          function _collect() {
            _collect.q.push(arguments);
          }
          _collect.q = _collect.q || [];
          win.TEA = win[export_obj] = _collect;
        }
        win[export_obj].l = +new Date();
      })(window, 'collectEvent');
    `;
    teaSdk.src =
      zone === 'cn'
        ? 'https://lf1-cdn-tos.bytescm.com/obj/static/log-sdk/collect/collect.js'
        : 'https://sf16-scmcdn-sg.ibytedtos.com/obj/static-sg/log-sdk/collect/collect.js';// sg
    // va:https://sf16-scmcdn-va.ibytedtos.com/obj/static-us/log-sdk/collect/collect.js
    document.body.appendChild(teaPre);
    setTimeout(() => {
      document.body.appendChild(teaSdk);
    }, 50);
    setTimeout(() => {
      resolve(true);
    }, 100);
  });
};

interface InitLogOptions {
  app_id: number;
  activity_id: number;
  default_data?: { [key: string]: any };
  zone?: string;
}


// let startTime = 0;
// 初始化APP_ID，ACTIVITY_ID
export const initSendLogV3 = ({ app_id, activity_id, default_data = {}, zone }: InitLogOptions) => {
  if (!zone) {
    throw new Error('gameSDK.Tea.initSendLogV3:\n初始化缺少zone(区域)字段，请根据业务地区来指定一个zone，中国:cn，海外地区:sg')
  }
  // 设置默认数据
  APP_ID = app_id;
  ACTIVITY_ID = activity_id;
  AREA_SIGNAL = zone;

  // 设置已初始化
  HAS_INITED_APP_ID = true;
  HAS_INITED_ACTIVITY_ID = true;

  // 添加默认通参
  let deafultKeys = Object.keys(default_data);
  deafultKeys.forEach(key => {
    DEFAULT_DATA[key] = default_data[key];
  });

  // 判断是否有tea sdk
  // if (!window.collectEvent && (!window.GameTool || !window.GameTool.collectEvent)) {
  //   console.log('***=== auto inject tea sdk  ===***')
  //   await preInstallTeaSdk(zone);
  // }
  console.log('***=== sendLogV3 inited ===***');
};

// 获取地理位置信息，只在正式环境有效
let getGeoCount = 0;
const getGeoInfo = async () => {
  // 只获取三次
  if (getGeoCount >= 3) {
    return;
  }
  try {
    const res = await window.fetch(
      `${location.origin ||
      ''}/act/${APP_ID}/location/geonameids?activity_id=${ACTIVITY_ID}&type=1`
    );
    const jsonData = await res.json();
    if (jsonData.data) {
      geoInfo = jsonData.data;
    }
  } catch (e) { }
  getGeoCount += 1;
};

// 时间分组
const timeGroups = {};

// 获取PassportV2放置在全局变量的passport_id
let getPassportId = () => {
  try {
    if ((window as any).ppuid_for_tea_gamesdk) {
      return (window as any).ppuid_for_tea_gamesdk
    }
    return BE_NULL;
  } catch (_) {
    return BE_NULL;
  }
}

// 设置通参参数，可动态新增/修改tea通参
export const setLogParam = (params) => {
  let keys = Object.keys(params);
  keys.forEach(key => {
    if (params[key]) {
      // 有值才赋值
      DEFAULT_DATA[key] = params[key]
    } else {
      // 无值删除，防止覆盖有值的默认参数
      delete DEFAULT_DATA[key];
    }
  });
}

export const sendLogV3 = async (event: string, params = {}, group_data = { name: "", type: 1 }, beconEvent = false) => {
  if (!HAS_INITED_APP_ID || !HAS_INITED_ACTIVITY_ID) {
    throw new Error(`
      请先调用gameSDK.Tea.initSendLogV3方法初始化app_id和activity_id.
      例如:
        gameSDK.Tea.initSendLogV3({app_id: 1781, activity_id: 123});
      注意: app_id和activity_id可询问相关对接人获取。
    `);
  }

  // 获取地理位置信息
  if (!HAS_FETCHED_GEO && !HAS_START_FETCH_GEO) {
    HAS_START_FETCH_GEO = true;
    await getGeoInfo();
    HAS_FETCHED_GEO = true;
  }

  const collectEvent = window.collectEvent || defaultLogMessageFn;

  // 设置header
  if (!HAS_CONFIG_CUS_HEADER) {
    const environment = getCustomsHeader();
    HAS_CONFIG_CUS_HEADER = true;
    collectEvent('config', {
      environment,
    });
  }

  let duration_json = {};
  if (group_data.name) {
    if (group_data.type === 2 && timeGroups[group_data.name]) {
      duration_json["duration"] = new Date().getTime() - timeGroups[group_data.name];
    } else {
      timeGroups[group_data.name] = new Date().getTime();
    }
  }

  // 获取URL query 参数
  let { open_id, role_id, device_id, server_id, from_source, token } = QUERY;
  let scenese = /BDGameSDK/i.test(navigator.userAgent);
  let actForms;
  if (!!window.runtime) {
    actForms = window.runtime.actForms;
  }
  if (!LAUNCH_FROM) {
    LAUNCH_FROM = getAppType();
  }
  if (!OS) {
    OS = getOS();
  }

  // 拼接公参数
  let _params = {
    aid: String(APP_ID),
    user_unique_id: open_id || BE_NULL,
    role_id: role_id || BE_NULL,
    device_id: device_id || BE_NULL,
    os: OS,
    launch_from: LAUNCH_FROM || BE_NULL,
    launch_way: BE_NULL,
    server_id: server_id ? +server_id : BE_NULL,
    activity_type: '2', // 活动类型：1：静态部署，2：红砖，3：非系统生成
    activity_id: String(ACTIVITY_ID),
    activity_link_id: from_source || BE_NULL,
    is_share: token ? location.href : BE_NULL,
    scenese: scenese ? '2' : '1',
    event_id: EVENT_ID,
    session_id: getSessionId(),
    timestamp: String(Date.now()),
    activity_form: (actForms || []).join(',') || BE_NULL,
    params_for_special: AREA_SIGNAL === 'cn' ? 'xuanwu' : 'xuanwu_overseas',
    url: location.origin + location.pathname,
    full_url: location.href,
    page_id: location.origin + location.pathname,
    refer_url: document.referrer || BE_NULL,
    passport_id: getPassportId(),
    ...duration_json,
    ...geoInfo,
    ...DEFAULT_DATA,
    ...params,
  };
  if (beconEvent) {
    return collectEvent('beconEvent', event, _params);
  }
  return collectEvent(event, _params);
};
